import { useState, useEffect } from "react";
import { Grid, Box, Dialog, DialogContent, } from "@mui/material";

import { NewButton, SpeakerModal } from "./index";
import styles from "./SpeakerCards.module.css";
import { tracking } from "../../../utils/tracking";
import _data from "../data/speakers_sc.json";

// _data = JSON.parse(_data)


export const SpeakerCards = ({ isSliced }) => {
   const [speakerIdx, setSpeakerIdx] = useState(null);
   const [numOfSpeakersToDisplay, setNumOfSpeakersToDisplay] = useState(isSliced ? 20 : Infinity);
   
   // const data = (isSliced? _data : {..._data, speakers: _data.speakers.sort((a, b) => a.lastname - b.lastname)})
   const data = _data;
   if (!isSliced) {
      data.speakers = data.speakers.sort((a, b) => a.lastname.localeCompare(b.lastname))
   }

   useEffect(() => {
   }, [numOfSpeakersToDisplay])

   const handleClose = () => setSpeakerIdx(null);

   const addMoreSpeakersToDisplay = () => {
      setNumOfSpeakersToDisplay(prev => prev + 20)
   }

   return (
      <div className={styles.investors} style={{ paddingBottom: !data?.total && '5em' }}>
         <h1>
            {data?.current_speakers ? `OUR FIRST ${data.total_display} FEATURED INVESTORS` : 'SPEAKERS COMING SOON'}
         </h1>
         {!data?.current_speakers && <br />}
         {!data?.current_speakers && <h2>View Featured Investors from our previous events</h2>}
         {data?.current_speakers && <br />}
         {data?.current_speakers && <h2>More Investors to be Announced</h2>}
         <br />
         {!data?.total > 0 && <div id='etxLoader' style={{ left: window.innerWidth > 900 ? '47.5%' : '40%', top: '85%' }} />}
         {
            data?.speakers?.length > 0 &&
            <div style={{ display: "flex", width: "100%", justifyContent: "center" }}>
               <Box sx={{ flexGrow: 0 }}>
                  <Grid
                     container
                     spacing={0}
                     columns={{ xs: 2, sm: 3, md: 4, lg: 5, xl: 5 }}
                     style={{
                        margin: "auto",
                        paddingRight: "5%",
                        justifyContent: "center",
                        paddingLeft: "5%",
                        maxWidth: "1698px",
                     }}
                     columnSpacing={{ xs: 0, sm: 0, md: 0, lg: 0, xl: 0 }}
                  >
                     {
                        data?.speakers?.slice(0, numOfSpeakersToDisplay).map((speaker, i) => {
                           return <Grid
                              className="grid-item"
                              key={i}
                              item
                              xs={1}
                              sm={1}
                              lg={1}
                              xl={1}
                              sx={{ maxWidth: "340px !important" }}
                           >
                              <div
                                 className="speaker-card"
                                 style={{
                                    borderRadius: "10px",
                                    margin: "1rem",
                                    padding: "1rem",
                                    alignItems: "stretch",
                                    maxWidth: "340px",
                                    height: "90%",
                                 }}
                                 key={i}
                                 onClick={() => {
                                    setSpeakerIdx(i)
                                 }}
                              >
                                 <img
                                    src={speaker.speaker_head_shot_to_display} alt=""
                                    style={{
                                       cursor: 'pointer',
                                       borderRadius: '5px',
                                       width: "100%",
                                       height: "auto",
                                    }}
                                 />
                                 <div
                                    style={{
                                       color: "#CF1B5B",
                                       fontWeight: window.innerWidth > 900 && "900",
                                       marginTop: "1.5vh",
                                       textAlign: 'center'
                                    }}
                                 >
                                    {speaker.firstname} {speaker.lastname}
                                 </div>
                                 <div style={{ color: "black", textAlign: 'center' }}>
                                    {speaker.company}
                                 </div>
                              </div>
                           </Grid>
                        })
                     }
                  </Grid>
               </Box>
            </div>
         }

         <Dialog
            disableScrollLock
            open={speakerIdx !== null}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
               sx: {
                  maxWidth: "1500px!important",
               },
            }}
         >
            <DialogContent style={{ overflow: "hidden" }}>
               <SpeakerModal speakers={data?.speakers} speakerIdx={speakerIdx} handleClose={handleClose} />
            </DialogContent>
         </Dialog>

         {
            isSliced && data?.total > 0 && numOfSpeakersToDisplay < data?.total &&
            <div onClick={() => { tracking(274); addMoreSpeakersToDisplay() }} className={styles.btn} >
               <NewButton name='SHOW MORE' color='white' bgColor='#CF1B5B' />
            </div>
         }
      </div >
   );
};
